package com.dignicate.web.data.content.static.home

import com.dignicate.web.data.content.TechnologyAreaDto
import com.dignicate.web.data.content.TechnologyCategoryDto
import com.dignicate.web.domain.Language
import com.dignicate.web.domain.LocalizedText
import com.dignicate.web.domain.LocalizedTexts

class TechnologiesContentSource {
    fun technologies(): List<TechnologyAreaDto> {
        return listOf(
            TechnologyAreaDto(
                id = "smartphone_apps",
                category = TechnologyCategoryDto.MOBILE,
                title = LocalizedTexts(
                    listOf(
                        LocalizedText(
                            Language.Ja,
                            "スマートフォンアプリ"
                        ),
                        LocalizedText(
                            Language.En,
                            "Smartphone applications"
                        )
                    )
                ),
                description = LocalizedTexts(
                    listOf(
                        LocalizedText(
                            Language.Ja,
                            "Android（Kotlin, Jetpack Compose）／iOS（Swift, SwiftUI）／Flutter／Kotlin Multiplatform を用いたモバイルアプリ開発に注力しています。MVVM やクリーンアーキテクチャ、DI などの設計を取り入れながら、機能追加や要件変更に耐えられる構造を重視しています。既存プロジェクトのリファクタリングや、UIKit / XML ベースから Compose / SwiftUI への段階的移行も対応可能です。"
                        ),
                        LocalizedText(
                            Language.En,
                            "We focus on mobile app development using Android (Kotlin, Jetpack Compose), iOS (Swift, SwiftUI), Flutter, and Kotlin Multiplatform. We design apps with MVVM, clean architecture, and dependency injection so that they remain maintainable as your product grows. We also work on refactoring existing projects and gradually migrating from legacy UI frameworks to modern stacks such as Compose and SwiftUI."
                        )
                    )
                )
            ),
            TechnologyAreaDto(
                id = "backend",
                category = TechnologyCategoryDto.BACKEND,
                title = LocalizedTexts(
                    listOf(
                        LocalizedText(
                            Language.Ja,
                            "バックエンド（必要に応じて）"
                        ),
                        LocalizedText(
                            Language.En,
                            "Backend & infrastructure (when needed)"
                        )
                    )
                ),
                description = LocalizedTexts(
                    listOf(
                        LocalizedText(
                            Language.Ja,
                            "基本的にはモバイルアプリ開発がメインですが、アプリを安定して動かすために必要な API やバックエンド（Kotlin / Ktor, AWS など）の実装・運用も、範囲を絞ってお受けしています。既存のサーバーサイドチームがいる場合は、そのチームと連携しながら、モバイル側の観点から API 設計や仕様調整をサポートします。"
                        ),
                        LocalizedText(
                            Language.En,
                            "While our primary focus is mobile, we can implement and operate the backend services required to keep your apps running reliably, using Kotlin (Ktor) and AWS. If you already have a server-side team, we collaborate with them and support API design from a mobile-first perspective."
                        )
                    )
                )
            ),
            TechnologyAreaDto(
                id = "process",
                category = TechnologyCategoryDto.PROCESS,
                title = LocalizedTexts(
                    listOf(
                        LocalizedText(
                            Language.Ja,
                            "プロセスとツール"
                        ),
                        LocalizedText(
                            Language.En,
                            "Process & tooling"
                        )
                    )
                ),
                description = LocalizedTexts(
                    listOf(
                        LocalizedText(
                            Language.Ja,
                            "GitHub / GitHub Actions などによる CI/CD や、Jira / Confluence / Notion 等のツールを用いたタスク・ドキュメント管理に対応します。ウォーターフォールやアジャイルといった開発手法の呼び方にこだわるのではなく、チームの規模やプロダクトのフェーズに合った現実的な開発フローを一緒に探るスタンスです。"
                        ),
                        LocalizedText(
                            Language.En,
                            "We support CI/CD with tools like GitHub and GitHub Actions, and work with issue/document tools such as Jira, Confluence, or Notion depending on your setup. Rather than enforcing a specific label like \"waterfall\" or \"agile\", we help you build a realistic development flow that matches your team size and product phase."
                        )
                    )
                )
            )
        )
    }
}
